/** @jsx jsx */
// Dependencies
import React, { FC } from 'react';
import {
  jsx,
  Container,
  Styled,
  Flex,
  Link,
  Grid,
  AspectRatio,
} from 'theme-ui';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';

// Components
import Layout from '../components/Layout/Layout';
import { Query } from '../../graphql-types';
import getUrl from '../shared/getUrl';
import SEO from '../components/SEO';
import { imageAssetFluid } from '../shared/imageAssetPath';

// Query
export const pageQuery = graphql`
  query SponsorsQuery {
    sanitySiteSettings {
      sponsors {
        ...sanitySponsor
      }
    }
  }
`;

// Props
interface SponsorPageProps {
  data: Pick<Query, 'sanitySiteSettings'>;
  styles?: {
    container: Object;
    content: Object;
    title: Object;
    box: Object;
    img: Object;
  };
}

// Components
const SponsorPage: FC<SponsorPageProps> = ({ data, styles }) => {
  const {
    sanitySiteSettings: { sponsors: sanitySponsors },
  } = data;
  return (
    <Layout>
      <SEO />
      <Container sx={styles.container}>
        <Grid columns={['1fr', '1fr 1fr']} gap={[2, 2, 5]}>
          {sanitySponsors &&
            sanitySponsors.map(({ logo, id, slug }) => {
              const imageFluid = imageAssetFluid(logo?.asset);
              return (
                <Link href={getUrl('Sponsor', slug)} key={id}>
                  <AspectRatio ratio={500 / 200} sx={styles.box}>
                    <Img
                      fluid={imageFluid}
                      imgStyle={{ objectFit: 'contain' }}
                      sx={styles.img}
                    />
                  </AspectRatio>
                </Link>
              );
            })}
        </Grid>
      </Container>
    </Layout>
  );
};

// Export
export default SponsorPage;

SponsorPage.defaultProps = {
  styles: {
    container: {
      position: 'relative',
      p: 2,
    },
    content: {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    title: {
      textAlign: 'center',
    },
    box: {
      backgroundColor: 'white',
      // m: ['10%', 2],
      p: 4,
      // maxWidth: '400px',
      // minWidth: ['80%', '400px'],
      // height: ['150px', '200px'],
    },
    img: {
      width: '100%',
      height: '100%',
    },
  },
};
